// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "TWSystems",
  middleName: "",
  lastName: "",
  message:
    "I build automation that works for you so that you can work on what matters.",
  icons: [
    {
      image: "fa-linkedin",
      url: "https://uk.linkedin.com/in/tarn-williamson",
    },
  ],
};

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/me.jpg"),
  imageSize: 375,
  message:
    "I'm Tarn Williamson, a software engineer with years of experience in high-stakes financial environments where reliability, accuracy, and testing standards are critical. I design practical automation that reduces manual workload, improves data quality, and scales with real operational needs. My focus is building solutions that are robust in production, easy for teams to adopt, and tailored to how people actually work. Please see above for examples of my recent work, or reach out to me directly using my email below.",
  resume: "https://google.com",
};

const repos = {
  show: true,
  heading: "Recent Projects",
  gitHubUsername: "hashirshoaeb", //i.e."johnDoe12Gh"
  reposLength: 4,
  specificRepos: [],
};

const recentWork = {
  show: true,
  heading: "Check Out My Recent Work",
  subheading:
    "Real automation projects, practical outcomes, and measurable improvements.",
  items: [
    {
      title: "CRM and Project Workflow Integration",
      subtitle: "HubSpot Integration Automation",
      image: require("../editable-stuff/integration.jpg"),
      imageAlt:
        "Automation flow integrating HubSpot with project management software",
      highlights: [
        'Integrated HubSpot with a "dumb" project management software where native integration simply did not exist',
        "Automated project creation and progression after deals were won, triggered directly by the CRM",
        "Removed manual handoffs where staff previously created and advanced project records themselves",
        "Delivered a hands-off workflow that saved at least 3 hours of manual admin per project, equivalent to 60+ team-hours per month at current project volume",
      ],
    },
    {
      title: "Digital Patient Intake and Sample Tracking",
      subtitle: "QR-Enabled Laboratory Kit Workflow",
      image: require("../editable-stuff/qr_scan.jpg"),
      imageAlt:
        "QR-based sample tracking workflow for a diagnostics laboratory",
      highlights: [
        "Replaced a handwritten form in tissue-sample kits with a QR code that directs patients to a digital form instead",
        "Used the same QR code at lab receipt so staff could confirm the sample had arrived",
        "Removed the need for staff to manually copy information from handwritten form to internal system and also improved end-to-end traceability",
        "Shifted roughly 75% of submissions away from paper, saving 40 hours a month and removing human error",
      ],
    },
    {
      title: "Handwritten Form Digitisation",
      subtitle: "Handwritten Intake Automation",
      image: require("../editable-stuff/form_filling.jpg"),
      imageAlt:
        "Scanning workflow for handwritten elderly-patient laboratory forms",
      highlights: [
        "For some elderly patients who still relied on handwritten forms (~25% of customers), built form-scanning software to process their submissions",
        "Captured and digitised key responses so staff no longer had to read and manually enter information",
        "Tailored the solution to real client needs where handwritten submissions remained common",
        "Saved around ~10 hours a month for a small team of only 4 staff members",
      ],
    },
  ],
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    {
      img: require("../editable-stuff/me.jpg"),
      label: "First slide label",
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum.",
    },
    {
      img: require("../editable-stuff/me.jpg"),
      label: "Second slide label",
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum.",
    },
  ],
  imageSize: {
    width: "615",
    height: "450",
  },
};

// SKILLS SECTION
const skills = {
  show: false,
  heading: "Skills",
  hardSkills: [
    { name: "Python", value: 90 },
    { name: "SQL", value: 75 },
    { name: "Data Structures", value: 85 },
    { name: "C/C++", value: 65 },
    { name: "JavaScript", value: 90 },
    { name: "React", value: 65 },
    { name: "HTML/CSS", value: 55 },
    { name: "C#", value: 80 },
  ],
  softSkills: [
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 90 },
    { name: "Positivity", value: 75 },
    { name: "Adaptability", value: 85 },
    { name: "Problem Solving", value: 75 },
    { name: "Empathy", value: 90 },
    { name: "Organization", value: 70 },
    { name: "Creativity", value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "If your team is losing time to re-keying data, chasing status updates, or stitching systems together by hand, I can help. For project enquiries, collaborations, or questions about where automation could make the biggest operational difference, contact me at:",
  email: "tw.systems@outlook.com",
};

const experiences = {
  show: false,
  heading: "Experiences",
  data: [
    {
      role: "Software Engineer",
      companylogo: require("../assets/img/dell.png"),
      date: "June 2018 – Present",
    },
    {
      role: "Front-End Developer",
      companylogo: require("../assets/img/boeing.png"),
      date: "May 2017 – May 2018",
    },
  ],
};

export {
  navBar,
  mainBody,
  about,
  repos,
  recentWork,
  skills,
  leadership,
  getInTouch,
  experiences,
};
